<template>
  <section class="section pt-5">
    <div class="container">
      <!-- Encabezado -->
      <div class="level mb-5">
        <div class="level-left">
          <div class="level-item">
            <div>
              <h1 class="title">{{ $t("priority_management") }}</h1>
              <p class="subtitle">{{ $t("manage_ticket_priorities") }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- DataTable de prioridades -->
      <priorities-datatable />
    </div>
  </section>
</template>

<script>
import PrioritiesDataTable from "./priorities_datatable/Index.vue";

export default {
  name: "HelpdeskPriorities",
  components: {
    "priorities-datatable": PrioritiesDataTable,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
